
import { FaDownload } from "react-icons/fa";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Grid, Modal, rem, ScrollArea, Stepper } from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../api/EndPoints";
import { createB2BAPI } from "../../../api/Interceptor";
import Navigation from "../sidebar/Navigation";
import Return from "./Return";
import silkImage from "../../../assets/silk.jpg";


import "./SpecificPlaceOrder.css";
import {
  IconArrowLeft,
  IconBan,
  IconCheck,
  IconHome,
  IconPackage,
  IconTruck,
} from "@tabler/icons-react";
import B2BButton from "../../common/B2BButton";
import moment from "moment";
import { generateAndDownloadPDF } from "../../../pdf/generateAndDownloadPDF";
import notify from "../../../utils/Notification";

const SpecificPlaceOrder = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 991px)");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const stateq = new URLSearchParams(location.state);
  const receiptNo = queryParams.get("receiptNo");
  const orderNo = queryParams.get("orderNo");
  const [specificOrder, setSpecificOrder] = useState([]);
  console.log(specificOrder, "ndddk")
  const navigate = useNavigate();
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const currentpath = location?.state?.activeTab;
  console.log(currentpath, "kkkkkkkkkk")
  const nrgpData = location?.state?.nrgp;
  const AllOrdeRItemsWithRib = location?.state?.AllItemWithRib;
  console.log(AllOrdeRItemsWithRib, "mmmmmmmmmmmmmmkkkkkkkkkkkkk")
  const pdfRef = useRef();
  const packingCharge =
    specificOrder.packingCharge *
    specificOrder?.items?.reduce((c, d) => c + d.qty, 0);

  const [isDownloading, setIsDownloading] = useState(false);

  // useEffect(() => {
  //   fetchSpecificData();
  // }, []);

  useEffect(() => {
    fetchorder();
  }, [AllOrdeRItemsWithRib, orderNo, receiptNo])
  const downloadInvoice = async (invoiceDocumentUrl) => {
    setIsDownloading(true);

    try {
      const res = await B2B_API.get(`vendor/download?filePath=${encodeURIComponent(invoiceDocumentUrl)}`, {
        responseType: 'blob',
      });

      const blob = await res.blob();
      const contentDisposition = res.headers.get("content-disposition");
      const fileName = contentDisposition
        ? contentDisposition.split("filename=")[1]?.replace(/"/g, '')
        : specificOrder?.invoiceDocumentUrl.split('/').pop();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      notify({
        title: 'Download Failed!',
        message: error?.message || 'Unable to download file.',
        error: true,
        success: false,
      });
    }

    finally {
      setIsDownloading(false);
    }
  };

  const getActiveStep = () => {
    if (specificOrder?.orderStatus === "CANCELLED") return -1;
    if (specificOrder?.orderStatus === "DELIVERED") return 4;
    if (specificOrder?.orderStatus === "SHIPPED") return 3;
    if (specificOrder?.orderStatus === "PACKED") return 2;
    if (
      ["CONFIRMED", "PAID", "INVOICED"].includes(specificOrder?.orderStatus)
    ) {
      return 1;
    }
    return 0;
  };

  const active = getActiveStep();
  const handleDownload = () => {
    if (specificOrder?.invoiceDocumentUrl !== null) {
      downloadInvoice(specificOrder?.invoiceDocumentUrl)
    } else {

      generateAndDownloadPDF(specificOrder);
    }
  }

  const fetchSpecificData = async () => {
    try {
      if (receiptNo) {
        const res = await B2B_API.get(`receipt/${receiptNo}`).json();
        setSpecificOrder(res.response);
      } else {
        const res = await B2B_API.get(`order/${orderNo}`).json();
        setSpecificOrder(res.response);
      }
    } catch (error) {
      console.error("Error fetching fabricInquiry:", error);
    }
  };
  const fetchorder = async () => {
    if (AllOrdeRItemsWithRib) {
      setSpecificOrder(AllOrdeRItemsWithRib);
    } else {
      fetchSpecificData()
    }
  }

  const BacktoPlaceOrder = () => {
    let url = '/place-Orders'
    if (specificOrder.orderType === 'SAMPLE') {
      url = `/place-Sample`
    }
    if (specificOrder.orderType === 'SWATCH') {
      url = `/place-Swatch`
    }
    navigate(url, {
      state: { activeTabFromLocation: currentpath },
    });
  };

  const [visible, { open, close }] = useDisclosure(false);
  const [nkVisible, { open: openNk, close: closeNk }] = useDisclosure(false); // separate modal control
  const [variantId, setVariantId] = useState("");
  const [isPaymentSummaryExpanded, setPaymentSummaryExpanded] = useState(true);
  const [returnStatus, setReturnStatus] = useState(false);

  const [selectedVariant, setSelectedVariant] = useState(null);
  console.log(selectedVariant, specificOrder, "full order")
  const returnModalClose = () => {
    setSpecificOrder((prev) => {
      if (!prev?.items) return prev;

      return {
        ...prev,
        items: prev.items.map((orderItem) => {
          if (orderItem.id === selectedVariant?.id) {
            return {
              ...orderItem,
              pickList: orderItem.pickList?.map((pick) => ({
                ...pick,
                returnedRolls: "",
                reason: "",
                rolls: pick.rolls?.map((roll) => ({
                  ...roll,
                  selected: false,
                  returnedRoll: false
                })) || []
              })) || []
            };
          }
          return orderItem;
        })
      };
    });

    close();
  };
  const comfirmReturn = async (item) => {
    const updatedPickList = item?.pickList?.map(pick => ({
      ...pick,
      rolls: pick.rolls?.map(roll => ({
        ...roll,
        returnedRoll: roll.selected === true
      }))
    })) || [];

    const body = {
      receiptNo: receiptNo,
      pickList: updatedPickList,
      variantSku: item?.productVariant?.variantSku,
      productName: item?.productVariant?.name,
      sellingPrice: item?.sellingPrice,
      noOfRolls:
        item?.pickList?.reduce(
          (total, item) => total + (parseInt(item?.returnedRolls) || 0),
          0
        ) || 0,
      pickListId: item?.pickList?.[0]?.pickListId || null,
      actualNoOfRolls:
        item?.pickList?.reduce(
          (total, item) => total + (item?.noOfRoll || 0),
          0
        ) || 0,
      invoicNo: specificOrder.invoice.invoiceNo,
    };

    try {
      console.log(body, "body biody")
      const response = await B2B_API.post(`return/save`, { json: body }).json();
      notify({
        error: false,
        success: true,
        title: response?.message || "Return saved successfully",
      });

      returnModalClose();
      fetchSpecificData();
    } catch (error) {
      console.error("Error during API call:", error);
      notify({
        error: true,
        title: error.message,
      });

    }
  };

  const togglePaymentSummary = () => {
    setPaymentSummaryExpanded((prevState) => !prevState);
  };

  const formatCurrency = (amount) => {
    const num = parseFloat(amount);
    return !isNaN(num) ? `Rs. ${num.toFixed(2)}` : "Rs. 0.00";
  };


  const formatDate = (date) => {
    return date ? new Date(date).toISOString().split("T")[0] : "";
  };

  useEffect(() => {
    setSpecificOrder((prev) => ({
      ...prev,
      returningRolls: 0,
      reason: "",
    }));
  }, [variantId]);
  const handleChange = (event, key) => {
    let val;
    if (event?.target?.type === "radio") {
      val = event?.target?.value;
    } else {
      val = event?.target?.value;
    }
    setSpecificOrder((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const packingCharges =
    parseFloat(specificOrder?.packingCharge) *
    parseFloat(
      specificOrder?.items?.reduce(
        (a, b) =>
          a + (specificOrder.orderType !== "WHOLESALE" ? 1 : b.qty / b.stdKg),
        0
      )
    );

  const getGrossTotal = useCallback(() => {
    if (specificOrder && specificOrder?.items) {
      let grossTotal = specificOrder?.items?.reduce(
        (acc, item) => acc + item.sellingPrice * item.qty,
        0
      );
      return grossTotal.toFixed(2);
    } else {
      return 0;
    }
  }, [specificOrder]);

  const downloadPDF = async () => {
    const input = pdfRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("invoice.pdf");
  };

  return (
    <div className="view-my-page router-view-container">
      <div className="route-view">
        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
          <B2BButton
            onClick={() => BacktoPlaceOrder()}
            style={{ backgroundColor: '#8BC53F', color: 'white' }}
            leftSection={<IconArrowLeft stroke={2} />}
            name="Back"
          />
        </div>
        {!isMobile && !isTablet && <Navigation />}
        <div></div>
        {currentpath !== "NRGP" && <div
          style={{ display: "flex", gap: "1rem", paddingTop: "1rem", flexDirection: isMobile ? "column" : "row", width: "100%" }}>
          <div className="col-4-12 biHiDs" style={{ boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.5)", width: isMobile ? "100%" : "30%", flexShrink: 0 }} >
            <div className="_4X-hBU">
              {specificOrder?.items?.some((m) => (m.partOfBundle === true)) && <div className="badge-sample-dark">
                BUNDLE
              </div>}
              {specificOrder?.items?.some((m) => (m.combo === true)) && <div className="badge-sample-dark">
                COMBO
              </div>}
              {specificOrder?.items?.some((m) => (m.combo !== true)) && <div className="badge-sample-dark" style={{ marginLeft: "5px" }}>
                {specificOrder?.orderType}
              </div>}
              <br />
              <br />
              <div className="fRiI6C">
                <div className="CWasv6" style={{ fontWeight: 'bolder' }}>
                  <span>
                    Order Date :{" "}
                    {new Date(
                      specificOrder?.billLocation?.createdDate
                    ).toLocaleDateString()}
                  </span>
                </div>
                <div className="CWasv6" style={{ fontWeight: 'bolder' }}>
                  <span>Order No : {specificOrder?.orderNo}</span>
                </div>
                <div className="CWasv6" style={{ fontSize: '15px' }}>
                  <span>
                    Total Order Qty :{" "}
                    {/* {specificOrder?.items
                      ?.map((item) =>
                        item?.actualOrderedQty
                          ? item.actualOrderedQty 
                          : 0
                      )
                      .reduce((sum, val) => sum + val, 0)} */}
                    {(() => {
                      const items = specificOrder?.items || [];
                      const totalQty = items
                        .map(item => item?.actualOrderedQty || 0)
                        .reduce((sum, val) => sum + val, 0);


                      return `${totalQty}`;
                    })()}
                  </span>
                </div>
                {specificOrder.orderType === 'WHOLESALE' && <div className="CWasv6" style={{ fontSize: '15px' }}>
                  <span>
                    Total No Of Rolls : {''}
                    {specificOrder?.items
                      ?.map((item) =>
                        item?.orderedRolls
                          ? item.orderedRolls
                          : 0
                      )
                      .reduce((sum, val) => sum + val, 0)}
                  </span>
                </div>}
                <div className="CWasv6" style={{ fontSize: '15px' }}>
                  <span>
                    Total Order Amt (Inc.Tax) : ₹{" "}
                    {Math?.round(specificOrder?.grossTotal).toFixed(2)}
                  </span>
                </div>
                <div className="CWasv6" style={{ fontSize: '15px' }}>
                  <span>
                    Order's Advance Payment :{" "}
                    <b>{specificOrder?.payment?.actualOrderStockpercentage ? Math?.round(specificOrder?.payment?.actualOrderStockpercentage) : "0"} %</b>
                  </span>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                <h6 style={{ color: 'green', fontSize: '10px' }}>Amount Paid : </h6>
                <span style={{ color: 'green', fontSize: '12px' }}>₹ {(
                  specificOrder?.payment?.paidAmount ? Math.round(specificOrder?.payment?.paidAmount).toFixed(2) : 'Not Paid')}</span>
              </div>
              <div className="Line-Bar"></div>
              <div className="LIF6mL">
                <span className="fRiI6C" style={{ fontWeight: "bold" }}>
                  Delivery Address
                </span>
              </div>
              <div className="pMQROX">
                <div className="CWasv6">
                  {specificOrder?.shipLocation?.nickName}
                </div>
                <div className="_0+LsShjkskjkjM">
                  {specificOrder?.shipLocation?.email}
                </div>
                <div className="oX3wY-">
                  {specificOrder?.shipLocation?.address1},{" "}
                  {specificOrder?.shipLocation?.address2},{" "}
                  {specificOrder?.shipLocation?.city} -{" "}
                  {specificOrder?.shipLocation?.pincode},{" "}
                  {specificOrder?.shipLocation?.state},{" "}
                  {specificOrder?.shipLocation?.country}
                </div>
                <span>
                  Phone number : {specificOrder?.shipLocation?.mobileNo}
                </span>
                <div className="cmrkae l+N8BC"></div>
                <div className="Line-Bar"></div>
                {specificOrder?.shipmentNote?.trackingId && (
                  <strong>
                    {" "}
                    This order is also tracking by{" "}
                    {specificOrder?.shipmentNote?.trackingId}
                  </strong>)}
              </div>
            </div>
          </div>
          {/* .............................................................................................................. */}
          <div className="Pg+ADy j2Lqqo" style={{ width: isMobile ? "100%" : "70%", overflow: "hidden" }} >
            <div className="KLkyDx">
              <div className="_7TNx1S">
                <ScrollArea type="always" scrollbarSize={8} offsetScrollbars >
                  <Box >
                    <div style={{ display: "grid", gridAutoFlow: "column", width: "max-content" }} >
                      {specificOrder?.items?.map((item) => (
                        <>
                          <React.Fragment key={item?.id}>
                            <div className="col-3-12 x6xEsd" key={item?.id} style={{ minWidth: "260px" }}>
                              {/* ................................................................................. */}
                              {/* JSX Structure */}
                              <div className="order-container">
                                {/* Item */}
                                <div className="roww">
                                  {/* Variant name at top left */}
                                  <div className="variant-name">
                                    {/* <span className="variant-name-text">
                             */}
                                    <h1 style={{ fontWeight: "bolder" }}>
                                      {item?.productVariant?.name}
                                    </h1>
                                  </div>

                                  {/* Image and content row */}
                                  <div className="image-content-row">
                                    {/* Image container */}
                                    <div className="img-container">
                                      <div className="image-wrapper">
                                        <img
                                          loading="lazy"
                                          className="product-imagee"
                                          alt={item?.productVariant?.name}
                                          src={`${BASE_URL}${item?.image?.replace("/api", "")}?time=${Date?.now()}`}
                                        />
                                      </div>
                                    </div>

                                    {/* Content on the right */}
                                    <div
                                      className="content-details"
                                      style={{ padding: "1rem" }}
                                    >
                                      {/* <div className="detail-item">
                                <span className="detail-label">
                                  Color :{" "}
                                  {item.productVariant?.variants.filter(
                                    (variant) => variant.type === "Colour"
                                  )[0]?.value || "N/A"}
                                </span>
                              </div> */}

                                      {item?.combo === true && <div className="inner-order-type">
                                        COMBO
                                      </div>}
                                      {item?.combo !== true && <div className="inner-order-type">
                                        {specificOrder?.orderType}
                                      </div>}
                                      <div className="detail-item">
                                        <span className="detail-label">
                                          UOM : {item?.uom || "N/A"}
                                        </span>
                                      </div>

                                      {specificOrder.orderType === 'WHOLESALE' && <div className="detail-item">
                                        <span className="detail-label">
                                          No of Rolls : {item?.orderedRolls?.toFixed(0) || "N/A"}
                                        </span>
                                      </div>}

                                      <div className="detail-item">
                                        <span className="detail-label">
                                          Total Qty :{" "}
                                          {specificOrder.receiptNo ?
                                            item.qty :
                                            item.actualOrderedQty}
                                        </span>
                                      </div>

                                      <div className="price">
                                        {specificOrder.orderType != "SWATCH" && "₹"}{item?.totalAmount?.toFixed(2) || 0}{specificOrder.orderType === "SWATCH" && " points"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {item?.ribItem && <div className="col-3-12 x6xEsd" key={item?.ribItem?.id}>
                              {/* ................................................................................. */}
                              {/* JSX Structure */}
                              <div className="order-container">
                                {/* Item */}
                                <div className="roww">
                                  {/* Variant name at top left */}
                                  <div className="variant-name">
                                    {/* <span className="variant-name-text">
                             */}
                                    <h1 style={{ fontWeight: "bolder" }}>
                                      {item?.ribItem?.productVariant?.name}
                                    </h1>
                                  </div>

                                  {/* Image and content row */}
                                  <div className="image-content-row">
                                    {/* Image container */}
                                    <div className="img-container">
                                      <div className="image-wrapper">
                                        <img
                                          loading="lazy"
                                          className="product-imagee"
                                          alt={item?.ribItem?.productVariant?.name}
                                          src={`${BASE_URL}${item?.ribItem?.image?.replace("/api", "")}?time=${Date?.now()}`}
                                        />
                                      </div>
                                    </div>

                                    {/* Content on the right */}
                                    <div
                                      className="content-details"
                                      style={{ padding: "1rem" }}
                                    >
                                      {/* <div className="detail-item">
                                <span className="detail-label">
                                  Color :{" "}
                                  {item.productVariant?.variants.filter(
                                    (variant) => variant.type === "Colour"
                                  )[0]?.value || "N/A"}
                                </span>
                              </div> */}
                                      {item?.ribItem?.rib === true && <div className="inner-order-type">RIB</div>}
                                      <div className="detail-item">
                                        <span className="detail-label">
                                          UOM : {item?.ribItem?.uom || "N/A"}
                                        </span>
                                      </div>

                                      {specificOrder.orderType === 'WHOLESALE' && <div className="detail-item">
                                        <span className="detail-label">
                                          No of Rolls : {item?.ribItem?.orderedRolls?.toFixed(0) || "N/A"}
                                        </span>
                                      </div>}

                                      <div className="detail-item">
                                        <span className="detail-label">
                                          Total Qty :{" "}
                                          {specificOrder.receiptNo ?
                                            item?.ribItem?.qty :
                                            item?.ribItem?.actualOrderedQty}
                                        </span>
                                      </div>

                                      <div className="price">
                                        {specificOrder.orderType != "SWATCH" && "₹"}{item?.ribItem?.totalAmount?.toFixed(2) || 0}{specificOrder.orderType === "SWATCH" && " points"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>}</React.Fragment>
                        </>
                      ))}
                    </div></Box> </ScrollArea>
                <div className="Line-Bar"></div>
                {getActiveStep() !== -1 && (
                  <div style={{ marginTop: "1.5rem" }}>
                    <Stepper
                      active={active}
                      size="sm"
                      orientation={isMobile ? "vertical" : "horizontal"}
                      styles={{
                        stepLabel: { fontWeight: "bold" },
                        separator: {
                          background: "#ccc", // Light gray dashed line for future steps
                        },
                      }}
                    >
                      {/* Step 0: New Order */}
                      <Stepper.Step
                        label="New Order"
                        description="Order has been placed"
                        completed={active > 0}
                        icon={
                          <IconPackage
                            style={{ width: rem(18), height: rem(15) }}
                          />
                        }
                        styles={{
                          root: { color: active >= 0 ? undefined : "#999" },
                          stepLabel: {
                            color: active >= 0 ? undefined : "#999",
                          },
                          description: {
                            color: active >= 0 ? undefined : "#999",
                          },
                        }}
                      >
                        <div className="Line-Bar" />
                        <div>
                          <span className="confirmed-text" >
                            YOUR ORDER IS YET TO BE CONFIRMED
                          </span>
                        </div>
                      </Stepper.Step>

                      {/* Step 1: Confirmed */}
                      <Stepper.Step
                        label="Confirmed"
                        description="Order has been confirmed"
                        completed={active > 1}
                        icon={
                          <IconCheck
                            style={{ width: rem(18), height: rem(18) }}
                          />
                        }
                        styles={{
                          root: { color: active >= 1 ? undefined : "#999" },
                          stepLabel: {
                            color: active >= 1 ? undefined : "#999",
                          },
                          description: {
                            color: active >= 1 ? undefined : "#999",
                          },
                        }}
                      >
                        <div className="Line-Bar"></div>
                        <span className="confirmed-text">
                          YOUR ORDER IS CONFIRMED
                        </span>
                      </Stepper.Step>

                      {/* Step 2: Packed */}
                      <Stepper.Step
                        label="Packed"
                        description="Ready to Dispatch"
                        completed={
                          active > 2 && specificOrder?.orderStatus === "PACKED"
                        }
                        icon={
                          <IconCheck
                            style={{ width: rem(18), height: rem(18) }}
                          />
                        }
                        styles={{
                          root: { color: active >= 2 ? undefined : "#999" },
                          stepLabel: {
                            color: active >= 2 ? undefined : "#999",
                          },
                          description: {
                            color: active >= 2 ? undefined : "#999",
                          },
                        }}
                      >
                        <div className="Line-Bar"></div>
                        <span className="confirmed-text">
                          YOUR ORDER IS READY TO DISPATCH
                        </span>
                      </Stepper.Step>

                      {/* Step 3: Shipped */}
                      <Stepper.Step
                        label="Shipped"
                        description="Order is on its way"
                        completed={active > 3}
                        icon={
                          <IconTruck
                            style={{ width: rem(18), height: rem(18) }}
                          />
                        }
                        styles={{
                          root: { color: active >= 3 ? undefined : "#999" },
                          stepLabel: {
                            color: active >= 3 ? undefined : "#999",
                          },
                          description: {
                            color: active >= 3 ? undefined : "#999",
                          },
                        }}
                      >
                        <div className="Line-Bar"></div>
                        <span className="confirmed-text">
                          YOUR ORDER IS BEING SHIPPED
                        </span>
                      </Stepper.Step>

                      {/* Step 4: Delivered */}
                      <Stepper.Step
                        label="Delivered"
                        description="Order has been delivered"
                        icon={
                          <IconHome
                            style={{ width: rem(18), height: rem(18) }}
                          />
                        }
                        styles={{
                          root: { color: active >= 4 ? undefined : "#999" },
                          stepLabel: {
                            color: active >= 4 ? undefined : "#999",
                          },
                          description: {
                            color: active >= 4 ? undefined : "#999",
                          },
                        }}
                      >
                        <div className="Line-Bar"></div>
                        <span className="confirmed-text">
                          Your order has been delivered.
                        </span>
                      </Stepper.Step>
                    </Stepper>
                  </div>
                )}
              </div>
              <div className="wCXmRX"></div>
              <div></div>
            </div>
          </div>
        </div>}

        {/* .......................................................................NRGP ......................... */}
        {currentpath === "NRGP" && <div
          style={{
            display: "flex",
            gap: "1rem",
            paddingTop: "1rem",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <div
            className="col-4-12 biHiDs"
            style={{
              boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.5)",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <div className="_4X-hBU">
              <div className="badge-sample-dark">
                {nrgpData?.nonReturnableLists[0]?.orderType}
              </div>
              <br />
              <br />
              <div className="fRiI6C">
                <div className="CWasv6" style={{ fontWeight: 'bolder' }}>
                  <span>
                    Order Date :{" "}
                    {new Date(
                      nrgpData?.createdDate
                    ).toLocaleDateString()}
                  </span>
                </div>
                <div className="CWasv6" style={{ fontWeight: 'bolder' }}>
                  <span>Order No : {nrgpData?.orderNo}</span>
                </div>
                <div className="CWasv6" style={{ fontSize: '15px' }}>
                  <span>
                    Total Order Qty:{" "}
                    {(() => {
                      const items = nrgpData?.nonReturnableLists || [];
                      const totalQty = items.reduce((total, item) => {
                        const rolls = item?.rolls || [];
                        const sumWeights = rolls.reduce(
                          (sum, roll) => sum + (roll?.actualWeight || 0),
                          0
                        );
                        return total + sumWeights;
                      }, 0);


                      return `${totalQty} `;
                    })()}
                  </span>
                </div>
                <div className="CWasv6" style={{ fontSize: '15px' }}>
                  <span>
                    Total No Of Rolls : {''}
                    {(() => {
                      const items = nrgpData?.nonReturnableLists || [];
                      const totalQty = items.reduce((total, item) => {
                        const rolls = item?.rolls || [];
                        const sumWeights = rolls.reduce(
                          (sum, roll) => sum + (roll?.noOfRoll || 0),
                          0
                        );
                        return total + sumWeights;
                      }, 0);


                      return `${totalQty}`;
                    })()}
                  </span>
                </div>
                <div className="CWasv6" style={{ fontSize: '15px' }}>
                  <span>
                    Total Order Amt (Inc.Tax): ₹{" "}
                    {Math?.round(nrgpData?.grossNonSaleableAmount).toFixed(2)}
                  </span>
                </div>
              </div>

              <div className="Line-Bar"></div>
              <div className="LIF6mL">
                <span className="fRiI6C" style={{ fontWeight: "bold" }}>
                  Delivery Address
                </span>
              </div>
              <div className="pMQROX">
                <div className="CWasv6">
                  {specificOrder?.shipLocation?.nickName}
                </div>
                <div className="_0+LsSMmk">
                  {specificOrder?.shipLocation?.email}
                </div>
                <div className="oX3wY-">
                  {specificOrder?.shipLocation?.address1},{" "}
                  {specificOrder?.shipLocation?.address2},{" "}
                  {specificOrder?.shipLocation?.city} -{" "}
                  {specificOrder?.shipLocation?.pincode},{" "}
                  {specificOrder?.shipLocation?.state},{" "}
                  {specificOrder?.shipLocation?.country}
                </div>
                <span>
                  Phone number : {specificOrder?.shipLocation?.mobileNo}
                </span>
                <div className="cmrkae l+N8BC"></div>
                <div className="Line-Bar"></div>
                {nrgpData?.returnShipmentNotes?.trackingId && (
                  <strong>
                    {" "}
                    This order is also tracking by{" "}
                    {nrgpData?.returnShipmentNotes?.trackingId}
                  </strong>)}
              </div>
            </div>
          </div>
          <div className="Pg+ADy j2Lqqo" style={{
            width: isMobile ? "100%" : "70%",
          }}>
            <div className="KLkyDx">
              <div className="_7TNx1S">
                <div style={{ display: "flex", rowGap: '1rem', justifyContent: 'center', marginTop: '2rem', flexWrap: 'wrap' }}>
                  {nrgpData?.nonReturnableLists?.map((item) => (
                    <div className="col-3-12 x6xEsd" key={item?.id}>
                      {/* JSX Structure */}
                      <div className="order-container">
                        {/* Item */}
                        <div className="roww">
                          {/* Variant name at top left */}
                          <div className="variant-name">
                            {/* <span className="variant-name-text">
                             */}
                            <h1 style={{ fontWeight: "bolder" }}>
                              {item?.productName}
                            </h1>
                          </div>

                          {/* Image and content row */}
                          <div className="image-content-row">
                            {/* Image container */}
                            <div className="img-container">
                              <div className="image-wrapper">
                                <img
                                  loading="lazy"
                                  className="product-imagee"
                                  alt={nrgpData?.productName}
                                  src={`${BASE_URL}${nrgpData?.productImageUrl?.replace("/api", "")}?time=${Date?.now()}`}
                                />
                              </div>
                            </div>

                            {/* Content on the right */}
                            <div
                              className="content-details"
                              style={{ padding: "1rem" }}
                            >
                              {/* <div className="detail-item">
                                <span className="detail-label">
                                  Color :{" "}
                                  {item.productName?.split("/")?.[1]?.trim()}
                                  
                                </span>
                              </div> */}

                              <div className="detail-item">
                                <span className="detail-label">
                                  UOM : {nrgpData?.uom || "N/A"}
                                </span>
                              </div>

                              {specificOrder.orderType === 'WHOLESALE' && <div className="detail-item">
                                <span className="detail-label">
                                  No of Rolls : {item?.rolls[0]?.noOfRoll?.toFixed(0) || "N/A"}
                                </span>
                              </div>}

                              <div className="detail-item">
                                <span className="detail-label">
                                  Total Qty :{" "}
                                  {item?.rolls[0]?.actualWeight}
                                </span>
                              </div>

                              <div className="price">
                                ₹ {nrgpData?.nonSaleableAmount?.toFixed(2) || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="Line-Bar"></div>
              </div>
              <div className="wCXmRX"></div>
              <div></div>
            </div>
          </div>
        </div>}
        {/* .......................................................................NRGP close ......................... */}

        {!["NEW", "CONFIRMED", "CANCELLED", "PACKED"].includes(
          specificOrder?.orderStatus
        ) && currentpath !== "NRGP" && (
            <>
              <br />
              <strong style={{ marginTop: "1rem" }} className="salesh1"> Payment Details</strong>
              <Grid style={{ marginTop: "1rem" }} __size="xL">
                <Grid.Col span={'auto'}>
                  {specificOrder?.packing && (
                    <Grid.Col span={'auto'} >
                      <div className="payment-summary-container">
                        <div className="payment-summary grid-item">
                          <h2
                            className="salesh2"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={togglePaymentSummary}
                          >
                            Payment Summary
                            <FontAwesomeIcon
                              icon={
                                isPaymentSummaryExpanded
                                  ? faChevronDown
                                  : faChevronUp
                              }
                            />
                          </h2>
                          {isPaymentSummaryExpanded && (
                            <div>
                              <div>
                                <div style={{ display: 'flex', gap: '1rem' }}>
                                  <span
                                    className={`payment-status ${specificOrder?.payment?.paymentStatus.toLowerCase()}`}
                                  >
                                    {specificOrder?.payment?.paymentStatus || "N/A"}
                                  </span>
                                  {specificOrder?.payment?.paymentApproved ? (
                                    <span className="verify-span">VERIFIED</span>
                                  ) : (
                                    <span className="verify-span">
                                      NOT VERIFIED
                                    </span>
                                  )}
                                </div>

                                <h3 style={{ marginTop: '1rem' }}>
                                  RECEIPT DETAILS{" "}
                                </h3>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
                                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <span>Receipt No :</span>
                                    <span>{specificOrder?.payment?.paidReferenceId || '-'}</span>
                                  </div>
                                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <span>Total Amt :</span>
                                    <span>{specificOrder?.payment?.totalAmount?.toFixed(2) || '0.00'}</span>
                                  </div>
                                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <span>Paid Amt :</span>
                                    <span>{specificOrder?.payment?.paidAmount?.toFixed(2) || '0.00'}</span>
                                  </div>
                                </div>
                                <h3 style={{ marginTop: '1rem' }}>INVOICE DETAILS{" "}</h3>
                                <div>
                                  <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    <span>E-Invoice No :</span>
                                    <span>{specificOrder?.einvoiceNo || '-'}</span>
                                  </div>
                                  <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    <span>E-Invoice Date :</span>
                                    <span>{moment(specificOrder?.einvoiceDate).format('DD/MM/YYYY') || '-'}</span>
                                  </div>
                                  <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    <span>IRN No :</span>
                                    <span>{specificOrder?.irnNo || '-'}</span>
                                  </div>
                                </div>
                                <h3 style={{ marginTop: '1rem' }}>LOGESTIC DETAILS{" "}</h3>
                                <div>
                                  <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    <span>E-Way Bill No :</span>
                                    <span>{specificOrder?.ewayBillNo || '-'}</span>
                                  </div>
                                  <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    <span>E-Way Bill Date :</span>
                                    <span>{moment(specificOrder?.ewayBillDate).format('DD/MM/YYYY') || '-'}</span>
                                  </div>
                                </div>
                              </div>
                              <br />
                            </div>
                          )}
                        </div>
                      </div>
                    </Grid.Col>
                  )}
                </Grid.Col>
                <Grid.Col span={isMobile ? 12 : (specificOrder?.packing ? 8 : 12)}>
                  <Grid.Col span={'auto'}>
                    <div className="billed-products grid-item">
                      <strong
                        className="salesh2"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            marginTop: "1rem",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <h2>INVOICE NO:</h2>

                          <span className="order-number">
                            {specificOrder?.invoice?.invoiceNo ||
                              "NOT YET INVOICED"}
                          </span>


                          {/* <ReactToPdf
                            targetRef={pdfRef}
                            filename={`Invoice-${specificOrder?.invoice?.invoiceNo || "Draft"}.pdf`}
                            options={{ orientation: "portrait", unit: "px", format: [794, 1123] }}
                            scale={0.9}
                          >
                            {({ toPdf }) => (
                              <button onClick={toPdf} style={{ marginTop: "20px" }}>
                                Download Invoice PDF
                              </button>
                            )}
                          </ReactToPdf> */}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                          {currentpath === "INVOICED" && <button
                            onClick={handleDownload}
                            className="SaleDownButt"
                            style={{ background: "#8BC53F", color: "black", borderRadius: "5px" }}
                          >
                            <span style={{ marginRight: "0.2rem" }}>Download Pdf</span>
                            <FaDownload size={12} /> {/* Smaller icon */}
                          </button>}
                          {currentpath === "DELIVERED" && <button
                            className="salesbuttonn"
                            style={{ background: "#8BC53F", color: "black", borderRadius: "5px", marginTop: "16px" }}
                            onClick={openNk}
                          >
                            Return details
                          </button>}
                        </div>
                      </strong>
                      <table className="salestable">
                        <thead>
                          <tr>
                            {specificOrder?.orderStatus === "DELIVERED" &&
                              specificOrder?.orderType !== "SWATCH" &&
                              specificOrder?.orderType !== "SAMPLE" && <th>S.No</th>}
                            <th>Product Name</th>
                            {specificOrder?.orderType === "WHOLESALE" ? (
                              <th>Rolls</th>
                            ) : (
                              <th>Qty</th>
                            )}
                            <th>UOM</th>
                            {specificOrder?.orderType === "WHOLESALE" && <th>Qty/Roll</th>}
                            <th>Sell Price/Qty</th>
                            <th>Total Amt.</th>
                            {/* {specificOrder?.orderType !== "SWATCH" &&
                            specificOrder.orderType !== "SAMPLE" && (
                              <th>Return Status</th>
                            )} */}
                          </tr>
                        </thead>
                        <tbody>
                          {specificOrder?.items?.map((row, index) => {
                            return (
                              <tr key={row?.id || index}>
                                {specificOrder?.orderStatus === "DELIVERED" &&
                                  specificOrder.orderType !== "SWATCH" &&
                                  specificOrder.orderType !== "SAMPLE" && (
                                    <td data-label="" className="radio-input-label">
                                      <div className="radio-input">
                                        {/* <input
                                        type="radio"
                                        checked={variantId === row?.id}
                                        className="radio-input"
                                        onClick={() => {
                                          setVariantId(row?.id);
                                          setReturnStatus(row?.returnStatus);
                                        }}
                                      /></div> */}
                                        {index + 1}</div>
                                    </td>
                                  )}
                                <td data-label="Product Name">
                                  {specificOrder.orderType !== "SWATCH"
                                    ? row?.productVariant?.name
                                    : row.productName}
                                  <br />
                                  {/* {specificOrder.orderType !== "SWATCH" ? (
                                    <>Order Kg: {row.qty} kg</>
                                  ) : (
                                    <>Order Quantity: {row.qty} point</>
                                  )} */}
                                </td>

                                {specificOrder.orderType === "WHOLESALE" ? (
                                  <td data-label="Rolls">
                                    {Math.round(row.orderedRolls)}
                                    {/* {row?.pickList ? (
                                      Math.ceil(
                                        row?.pickList
                                          ?.reduce(
                                            (total, item) =>
                                              total + (item?.noOfRoll || 0),
                                            0
                                          )
                                          .toFixed(2)
                                      )
                                    ) : (
                                      <>-</>
                                    )} */}
                                  </td>
                                ) : (
                                  <td data-label="Qty">{row.qty}</td>
                                )}
                                <td data-label="UOM">{row.uom}</td>
                                {specificOrder?.orderType === "WHOLESALE" && <td data-label="Qty/Roll">{row.stdKg}</td>}
                                <td data-label="Sell Price/Qty">{specificOrder.orderType !== "SWATCH" && "Rs."}{row.sellingPrice}{specificOrder.orderType === "SWATCH" && " points"}</td>

                                <td data-label="Total Amt.">{row.totalAmount.toFixed(2)}</td>
                                {/* {specificOrder?.orderType !== "SWATCH" &&
                                specificOrder?.orderType !== "SAMPLE" && (
                                  <td>
                                    {row?.returnStatus
                                      ? "Returned"
                                      : "Not Returned"}
                                  </td>
                                )} */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="remarks-totals-section">
                        <div className="totals-section">
                          <div className="chargegroup">
                            <label>Total(Products) :</label>
                            <p>{specificOrder?.orderType !== "SWATCH" && "₹ "}{specificOrder.totalProductAmount || 0}{specificOrder?.orderType === "SWATCH" && " points "}</p>
                          </div>
                          <div className="chargegroup">
                            <label>Packing Charges :</label>
                            <p>₹ {specificOrder?.totalPackingCharge}</p>
                          </div>
                          <div className="chargegroup">
                            <label>Shipment Charges :</label>
                            <p>₹ {specificOrder?.shipmentCost?.toFixed(2) || 0}</p>
                          </div>
                          <div style={{ backgroundColor: "#d0edac", color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: "0.5rem", paddingLeft: "0.5rem", borderRadius: "5px", fontSize: '18px' }}>
                            <label style={{ color: 'black' }}>Total(Excl.Taxes) :</label>
                            <p style={{ color: 'black' }}>
                              ₹ {(
                                parseFloat(
                                  specificOrder.totalProductAmount || 0
                                ) +
                                parseFloat(specificOrder?.totalPackingCharge) +
                                parseFloat(specificOrder?.shipmentCost || 0) -
                                parseFloat(
                                  specificOrder?.grossConeWieghtPrice || 0
                                )
                              ).toFixed(2)}
                            </p>
                          </div>
                          <div className="chargegroup">
                            <label>
                              IGST Charges ({0}%):
                            </label>
                            ₹ 0.00
                          </div>

                          <div className="chargegroup">
                            <label>
                              CGST Charges (
                              {specificOrder?.items?.[0]?.gstRate != null ? specificOrder.items[0].gstRate / 2 : "-"}  %):
                            </label>
                            <p>
                              ₹  {specificOrder?.totalGst != null ? (specificOrder.totalGst / 2).toFixed(2) : "-"}
                            </p>
                          </div>

                          <div className="chargegroup">
                            <label>
                              SGST Charges (
                              {specificOrder?.items?.[0]?.gstRate != null ? specificOrder.items[0].gstRate / 2 : "-"} %):
                            </label>
                            <p>
                              ₹ {specificOrder?.totalGst != null ? (specificOrder.totalGst / 2).toFixed(2) : "-"}
                            </p>
                          </div>
                          <div className="chargegroup">
                            <label>Total Amt :</label>
                            <p>
                              ₹ {(
                                parseFloat(specificOrder?.grossTotal || 0)
                              ).toFixed(2)}
                            </p>
                          </div>
                          <div className="chargegroup">
                            <label>Round Off :</label>
                            <p>₹ {(specificOrder?.adjustedAmount)?.toFixed(2)}</p>
                          </div>
                          <div className="chargegroup" style={{ backgroundColor: "#bee392", paddingRight: "0.5rem", paddingLeft: "0.5rem", color: 'white', margin: "0", borderRadius: "5px" }}>
                            <p style={{ color: 'black' }}>
                              <strong>TOTAL AMT (Rounded Off):</strong>
                            </p>
                            <p style={{ color: 'black' }}> ₹ {Math?.round(specificOrder?.grossTotal).toFixed(2)} </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid.Col>
                </Grid.Col>
              </Grid>
              {
                <Modal
                  opened={visible}
                  onClose={close}
                  centered
                  size={isMobile ? "100%" : "70%"}
                  title={
                    <span
                    >
                      {"Return DashBoard"}
                    </span>
                  }
                >
                  {
                    <Return
                      item={selectedVariant}
                      setOrder={setSpecificOrder}
                      order={specificOrder}
                      handleChange={handleChange}
                      comfirmReturn={comfirmReturn}
                      returnModalClose={returnModalClose}
                    />
                  }
                </Modal>
              }
              <Modal
                opened={nkVisible}
                onClose={closeNk}
                centered
                title="Product return details"
                size={isMobile ? "100%" : "70%"}
              >{
                  <table className="salestable">
                    <thead>
                      <tr>
                        {specificOrder?.orderStatus === "DELIVERED" &&
                          specificOrder?.orderType !== "SWATCH" &&
                          specificOrder?.orderType !== "SAMPLE" && <th>S.No</th>}
                        <th>Product Name</th>
                        {specificOrder?.orderType === "WHOLESALE" ? (
                          <th>Rolls</th>
                        ) : (
                          <th>Qty</th>
                        )}
                        <th>UOM</th>
                        {specificOrder?.orderType === "WHOLESALE" && <th>Qty/Roll</th>}
                        <th>Sell Price/Qty</th>
                        <th>Total Amt.</th>
                        <th>Returns</th> {/* 🔥 new column header */}
                        {/* {specificOrder?.orderType !== "SWATCH" &&
                            specificOrder.orderType !== "SAMPLE" && (
                              <th>Return Status</th>
                            )} */}
                      </tr>
                    </thead>

                    <tbody>
                      {specificOrder?.items?.filter(row => row?.returns)?.length > 0 ? (
                        specificOrder.items
                          .filter(row => row?.returns)
                          .map((row, index) => (
                            console.log(row, "rowss "),
                            <tr key={row?.id || index}>
                              {specificOrder?.orderStatus === "DELIVERED" &&
                                specificOrder.orderType !== "SWATCH" &&
                                specificOrder.orderType !== "SAMPLE" && (
                                  <td data-label="S.No" >
                                    <div className="radio-input">{index + 1}</div>
                                  </td>
                                )}
                              <td data-label="Product Name">
                                {specificOrder.orderType !== "SWATCH"
                                  ? row?.productVariant?.name
                                  : row.productName}
                                <br />
                              </td>
                              {specificOrder.orderType === "WHOLESALE" ? (
                                <td data-label="Rolls">{row.orderedRolls}</td>
                              ) : (
                                <td data-label="Qty">{row.qty}</td>
                              )}
                              <td data-label="UOM">{row.uom}</td>
                              {specificOrder?.orderType === "WHOLESALE" && (
                                <td data-label="Qty/Roll">{row.stdKg}</td>
                              )}
                              <td data-label="Sell Price/Qty">Rs.{row.sellingPrice}</td>
                              <td data-label="Total Amt">{row.totalAmount.toFixed(2)}</td>
                              <td data-label="Returns">
                                <button
                                  className="salesbuttonn"
                                  style={{ background: "#8BC53F", color: "black", borderRadius: "5px" }}
                                  onClick={() => {
                                    setSelectedVariant(row);
                                    open();
                                    closeNk();
                                  }}
                                >
                                  {row?.returnStatus ? "View Returns" : "Process Return"}
                                </button>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan="100%" style={{ textAlign: "center", padding: "1rem" }}>
                            No returns available
                          </td>
                        </tr>
                      )}
                    </tbody>


                  </table>}
              </Modal>

            </>
          )
        }
      </div >
    </div >
  );
};

export default SpecificPlaceOrder;